import { DollarIcon, PurchaseVolumeIcon, InvoiceIcon, TransactionIcon } from "./svg/icons/icon";
import { useNavigate } from "react-router";
import { useEffect, useState, useContext } from "react";
import Contextapi from '../context-api/createContext';
import axios from "axios";
import { baseUrl } from '../utils.jsx/baseUrl';
import ReactApexChart from 'react-apexcharts';

function DashboardAnalytics() {
  // const { setIsnavabr } = useContext(Contextapi);
  const navigate = useNavigate();
  const [isverified, setIsverified] = useState(false);
  const [data, setData] = useState(null);
  const token = sessionStorage.getItem('token');
  const ckey = sessionStorage.getItem('client_key');

  useEffect(() => {
    if (sessionStorage.getItem('sid')) {
      sessionStorage.removeItem('sid');
    }

    (async () => {
      if (ckey !== "null" && ckey !== null) {
        try {
          let res = await axios.get(`${baseUrl.url}/calculate/data/${ckey}`, {
            headers: {
              // Authorization: `Bearer ${token}`
            }
          });

          console.log(res.data, "response");
            setData(res.data);
            // setIsnavabr(true);
        } catch (error) {
          // console.log(error);
          // console.error("Error fetching data:", error);
          if (error.response && error.response.status === 404) {
            // console.log("404 error caught, setting state to empty");
            setData({});
          }
          // navigate('/login');
        }
      }
    })();
  }, [ckey, baseUrl.url, navigate]);

  function isEmpty(obj) {
    for (var prop in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        return false;
      }
    }
    return true;
  }

  let data1 = [];

  if (!isEmpty(data)) {
    data1 = Object.values(data.aging);
  }

  console.log(data1 , "data12")
  const chartData = {
    series: [{
      data: data1
    }],
    options: {
      chart: {
        type: 'bar',
        height:"250",
        toolbar: {
          show: false,
          tools: {
            download: false
          }
        }
      },
      plotOptions: {
        bar: {
          borderRadius: 1,
          // horizontal: true,
        }
      },
      dataLabels: {
        enabled: false
      },
      xaxis: {
        categories: ["1-30", "31-60", "61-90", "91-120", "121+"],
      },
    }
  };

  // console.log(data , "data", typeof data , "data" , isEmpty(data)) 
  // return (
  //   <>
  //     <div className="max-w-[1168px] w-full grid mx-auto rounded-md mt-[41px] mb-7">
  //       <p className='w-full text-[#212121] font-semibold text-2xl'>Dashboard Analytics</p>

  //       <div className='flex gap-10 py-8'>
  //         <div className='w-1/4 bg-blue-600 px-8 py-6 rounded-md'>
  //           <p className='pb-14'><DollarIcon /></p>
  //           <p className='text-[#F1F1F1] text-[20px] font-normal leading-8'>Total Account Receivables Balance:</p>
  //           <p className='text-[#F1F1F1] text-[28px] font-semibold leading-10 pt-4'>${isEmpty(data) ? 0 : (Number(data?.CurrBalAmt)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
  //         </div>

  //         <div className='bg-[#F5F5F5] p-8 rounded-md w-1/3'>
  //           <p className='text-[16px] font-medium leading-6 pb-6'>Client Summary Aging</p>
  //           <ReactApexChart options={chartData.options} series={chartData.series} type="bar" height={200} />
  //         </div>

  //         <div className='bg-[#F5F5F5] p-8 rounded-md w-1/3'>
  //           <div className='pb-8 flex justify-between'>
  //             <p className='text-[16px] font-medium leading-6'>Factoring Totals</p>
  //             <p className='text-[12px] font-medium leading-3 pt-1'>30 Days</p>
  //           </div>

  //           <div className='flex gap-6'>
  //             <div className='px-4 py-6 bg-gray-200 rounded-md w-fit'>
  //               <p className='pb-6'><PurchaseVolumeIcon /></p>
  //               <p className='text-[14px] font-normal leading-5'>Purchase Volume</p>
  //               <p className='text-[20px] font-medium leading-9 text-[#258CFB]'>${isEmpty(data) ? 0 : (data.totalAmt).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
  //             </div>
  //             <div className='gap-5 flex flex-col'>
  //               <div className='px-3 py-3 bg-gray-200 rounded-md'>
  //                 <div className='flex gap-3'>
  //                   <p className='pt-4'><TransactionIcon /></p>
  //                   <div>
  //                     <p className='text-[14px] font-normal leading-5'>Transactions</p>
  //                     <p className='text-[20px] font-medium leading-9 text-[#258CFB]'>{isEmpty(data) ? 0 : data.transactionsCount}</p>
  //                   </div>
  //                 </div>
  //               </div>

  //               <div className='px-3 py-3 bg-gray-200 rounded-md'>
  //                 <div className='flex gap-3'>
  //                   <p className='pt-4'><InvoiceIcon /></p>
  //                   <div>
  //                     <p className='text-[14px] font-normal leading-5'>Invoices</p>
  //                     <p className='text-[20px] font-medium leading-9 text-[#258CFB]'>{isEmpty(data) ? 0 : data.invoiceCount}</p>
  //                   </div>
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //       </div>

  //       {!isEmpty(data) && data?.debtors && (
  //         <>
  //           <p className='text-[24px] text-[#212121] font-semibold'>{`Top ${data.debtors.length} Debtors`}</p>
  //           {data.debtors.map((item) => (
  //             <div key={item.Name} className="">
  //               <div className='flex justify-between py-4 bg-white rounded-md px-7 mb-1 mt-4'>
  //                 <p className='text-[16px] leading-6 font-normal'>{item?.Name}</p>
  //                 <p className='text-[20px] font-medium leading-7'>${(item?.Balance).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
  //               </div>
  //             </div>
  //           ))}
  //         </>
  //       )}
  //     </div>
  //   </>
  // );

  return (
    <>
      <div className=" w-full grid rounded-md  ">
        {/* <p className='w-full text-[#212121] font-semibold text-2xl'>Dashboard Analytics</p> */}

        <div className='flex flex-col xl:flex-row gap-10 h-auto'>
          <div className=' bg-blue-600 py-4 pl-4 pr-14 rounded-lg w-[1/3]'>
            <p className=''><DollarIcon /></p>
            <p className='text-[#F1F1F1] text-[22px] font-normal leading-8'>Total Account Receivables Balance:</p>
            <p className='text-[#F1F1F1] text-[28px] font-semibold leading-10 '>${isEmpty(data) ? 0 : (Number(data?.CurrBalAmt)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
          </div>


          <div className='px-3 rounded-md w-full'>
            <div className='pb-8 flex justify-between'>
              <p className='text-[18px] font-medium leading-6'>Factoring Totals</p>
              <p className='text-[18px] font-normal leading-3 border border-1 p-2 rounded-md'>30 Days</p>
            </div>

            <div className='grid grid-cols-1 lg:grid-cols-3  gap-6 w-full'>
              <div className='pr-12 pl-4  py-11 bg-white rounded-lg '>
                <div className='flex gap-3 '>
                <p className='pt-4'><PurchaseVolumeIcon /></p>
                <div>
                <p className='text-[18px] font-normal leading-5'>Purchase Volume</p>
                <p className='text-[24px] font-medium leading-9 text-[#258CFB]'>${isEmpty(data) ? 0 : (data?.totalAmt).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
              </div>
              </div>
              </div>
              {/* <div className='gap-5 flex '> */}
                <div className='pr-12 pl-4 py-11 bg-white rounded-lg'>
                  <div className='flex gap-3'>
                    <p className='pt-4'><TransactionIcon /></p>
                    <div>
                      <p className='text-[18px] font-normal leading-5'>Transactions</p>
                      <p className='text-[24px] font-medium leading-9 text-[#258CFB]'>{isEmpty(data) ? 0 : data.transactionsCount}</p>
                    </div>
                  </div>
                </div>

                <div className='pr-12 pl-4 py-11 bg-white rounded-lg'>
                  <div className='flex gap-3'>
                    <p className='pt-4'><InvoiceIcon /></p>
                    <div>
                      <p className='text-[18px] font-normal leading-5'>Invoices</p>
                      <p className='text-[24px] font-medium leading-9 text-[#258CFB]'>{isEmpty(data) ? 0 : data.invoiceCount}</p>
                    </div>
                  </div>
                </div>
              {/* </div> */}
            </div>
          </div>
        </div>
       
        { 
        // !isEmpty(data) &&  
         data?.debtors && ( 
        <div className = "grid grid-cols-1 lg:grid-cols-2 my-10 gap-10">
        <div>
            <p className='text-[18px] font-medium leading-6 pb-6'>Client Summary Aging</p>
      <div className=' p-8 rounded-lg  bg-white'>
           <ReactApexChart options={chartData.options} series={chartData.series} type="bar" height={380} /></div>
          </div>

       
         
           <div> <p className='text-[18px] font-medium leading-6 pb-6'>{`Top ${data && data.debtors && data.debtors.length} Debtors`}</p>
             <div className='p-8 rounded-lg bg-white'>
            {data && data.debtors && data.debtors.map((item) => (
              <div key={item.Name} className="">
                <div className='flex justify-between py-4 bg-[#F9FAFB] border border-1 rounded-lg px-7 mb-1 mt-4'>
                  <p className='text-[16px] leading-6 font-normal'>{item?.Name}</p>
                  <p className='text-[20px] font-medium leading-7'>${(item?.Balance).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                </div>
              </div>
            ))}
            </div>
            </div>
          </div>
        )}  
      </div>
    </>
  )
}

export default DashboardAnalytics;
